import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PageHeader, Dropdown, Menu, Button, Spin, Badge, Modal } from 'antd';
import { EditOutlined, DashboardOutlined, DownOutlined, PlusOutlined, SettingOutlined, CloseOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest';
import * as ToolPermission from '../../tools/ToolPermission';

import SpinFull from '../../components/SpinFull';
import SuperTable from '../../components/SuperTable';

export default function FarmSiteViewScreen(props) {
  const history = useHistory();
  const userData = useSelector(state => state.user);
  const userPermissionsData = useSelector(state => state.userPermissions);

  const isAllowedCrossCompany = ToolPermission.hasPermission(userPermissionsData, 'ui:company', 'get:xc');

  const [loaded, setLoaded] = useState(false);
  const [tableKey, setTableKey] = useState(Math.random().toString());
  const [searchCompanyOptions, setSearchCompanyOptions] = useState([]);

  const columns = [
    {
      template: 'action',
      key: 'action',
      width: 80,
      render: (value, record) => {
        return (
          <Dropdown.Button
            type="default"
            onClick={() => {
              history.push(`/farm-site/dashboard/${record.id}`);
            }}
            overlay={
              <Menu onClick={value => {
                switch (value.key) {
                  case 'edit': {
                    history.push(`/farm-site/edit/${record.id}`);
                    break;
                  }
                  case 'edit-stations': {
                    history.push(`/farm-site/edit/${record.id}/station/edit`);
                    break;
                  }
                  case 'remove': {
                    Modal.confirm({
                      title: 'Confirm to REMOVE site',
                      content: 'Are you sure to remove this site?',
                      onOk: () => {
                        (async () => {
                          await ToolRequest.request('DELETE', `/v1/farm-site/${record.id}`);

                          setTableKey(Math.random().toString());
                        })();
                      },
                    });
                    break;
                  }
                }
              }
            }>
              <Menu.Item key="edit">
                <EditOutlined />
                Edit
              </Menu.Item>
              <Menu.Item key="edit-stations">
                <EditOutlined />
                Bind Stations
              </Menu.Item>
              <Menu.Item key="remove">
                <CloseOutlined />
                Remove
              </Menu.Item>
            </Menu>
          }>
            <DashboardOutlined />
            Dashboard
          </Dropdown.Button>
        );
      },
    },
    {
      template: 'id',
      key: 'id',
      width: 40,
      title: 'ID',
    },
    {
      key: 'name',
      title: 'Name',
    },
    {
      key: 'companyName',
      title: 'Company',
    },
    {
      key: 'address',
      title: 'Address',
    },
    {
      key: 'isEnabled',
      title: 'Status',
    },
  ];

  const searchColumns = [
    ...(isAllowedCrossCompany ? [{
      template: 'cascader',
      key: 'companyId',
      title: 'Company',
      options: searchCompanyOptions,
    }] : []),
  ];

  const searchQueryParams = values => {
    return {
      companyId: values.companyId ? values.companyId[0] : undefined,
    };
  };

  useEffect(() => {
    (async () => {
      if (isAllowedCrossCompany) {
        const companyRes = await ToolRequest.request('GET', '/v1/company', {
          count: 1000,
        });

        setSearchCompanyOptions(companyRes.data.map(company => ({
          value: company.id,
          label: company.displayName,
        })));
      }

      setLoaded(true);
    })();
  }, []);

  const loadDataSource = async (body) => {
    const siteRes = await ToolRequest.request('GET', '/v1/farm-site', {
      ...body,
    });

    const companyIds = siteRes.data.filter(site => site).map(site => site.companyId).filter((value, index, self) => self.indexOf(value) === index);

    const companies = await Promise.all(companyIds.map(companyId => ToolRequest.request('GET', `/v1/company/${companyId}`).catch(err => {})));

    return {
      data: siteRes.data.map(site => {
        const company = companies.find(company => company && company.id === site.companyId);
        return {
          ...site,
          companyName: company?.displayName || '-',
        };
      }),
      totalCount: siteRes.totalCount,
    };
  };

  return loaded ? (
    <PageHeader
      title="Site List"
      extra={[
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => history.push('/farm-site/add')}
        >
          Add Site
        </Button>
      ]}
    >
      <SuperTable
        searchColumns={searchColumns}
        searchQueryParams={searchQueryParams}
        tableKey={tableKey}
        onTableKeyChange={key => setTableKey(key)}
        loadDataSource={loadDataSource}
        columns={columns}
      />
    </PageHeader>
  ) : <SpinFull />;
};
